/* pages/Lost.jsx — a page that doesn't exist. Proto, not a bare 404. */

import { go } from '../lib/router.js';
import { Button } from '../ui/ui.jsx';
import { ProtoCard, lost } from '../ui/proto.jsx';

export function Lost() {
  return (
    <div class="center-page">
      <ProtoCard title="Page not found" text={lost()} actions={<Button kind="primary" onClick={() => go('/')}>Back to your docs</Button>} />
    </div>
  );
}
